// Courtesy of https://medium.com/spektrakel-blog/a-simple-lru-cache-in-typescript-cba0d9807c40

export class LRUCache<Key, Value> {
    private values: Map<Key, Value> = new Map<Key, Value>();
    private maxEntries: number;

    constructor(maxEntries: number = 3) {
        this.maxEntries = maxEntries;
    }

    public get(key: Key): Value|undefined {
        const hasKey = this.values.has(key);
        let entry: Value|undefined = undefined;
        if (hasKey) {
          // peek the entry, re-insert for LRU strategy
          entry = this.values.get(key);
          this.values.delete(key);
          if (entry !== undefined) { this.values.set(key, entry); }
        }
        return entry;
      }

    public put(key: Key, value: Value) {
        if (this.values.size >= this.maxEntries) {
          // least-recently used cache eviction strategy
          const keyToDelete = this.values.keys().next().value;

          this.values.delete(keyToDelete);
        }

        this.values.set(key, value);
    }
}